import React, { useState } from "react";
import "./LoanApprovalDashboard.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";

import AllRequests from "./AllRequests";
import PendingRequests from "./PendingRequests";
import AgreementRequests from "./AgreementRequests";
import {
  CustomTabPanel,
  a11yProps,
} from "../../Helpers/CustomTabPanel/CustomTabPanel";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";
import InputForm from "../../Components/InputForm/InputForm";
import AllRequestsFilters from "./Filters/AllRequestsFilters";
import LoanApprovalGrid from "./Grid/LoanApprovalGrid";
import { LoanDashboardModules } from "../../Helpers/Enums/LoanDashboardModules";
import { ITab } from "./Interfaces/ITab";
import { LoanDashboardEventTarget } from "./Enums/LoanDashboardEventTarget";
import { ILoanApprovalFilters } from "./Grid/ILoanApprovalGrid";
import { Tooltip } from "@mui/material";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { ExportToExcel } from "./Helpers/GridHelper";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { getContext } from "../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import "./Style.css";
import { LoanRepaymentDashboardEventTarget } from "./Enums/LoanRepaymentDashboardEventTarget";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import {
  GetLoanRepaymentExportToExcel,
  GetLoanRequestDataExportToExcel,
  LoanExportToCSV,
} from "../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";

const LoanApprovalDashboard = () => {
  const navigate = useNavigate();
  const context = getContext();

  const [value, setValue] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] =
    useState<ILoanApprovalFilters>(null);
  const [dataCount, setDataCount] = useState(0);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);

  const [tabs, setTabs] = useState<ITab[]>([
    {
      label: "Loan Requests",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible: true,
      id: "all-requests",
      target: LoanDashboardEventTarget.TabAllRequestsClick,
      module: LoanDashboardModules.All,
    },
    {
      label: "Pending Requests",
      value: { ...a11yProps(1) },
      count: 0,
      active: false,
      visible: context?.CurrentRoleId === RoleEnum.InternalTeam,
      id: "pending-requests",
      target: LoanDashboardEventTarget.TabApprovalPendingClick,
      module: LoanDashboardModules.Pending,
    },
    {
      label: "Agreement Requests", // (Approved by Member requests)
      value: { ...a11yProps(2) },
      count: 0,
      active: false,
      visible: context?.CurrentRoleId === RoleEnum.InternalTeam,
      id: "agreement-requests",
      target: LoanDashboardEventTarget.TabAgreementRequestClick,
      module: LoanDashboardModules.Agreement,
    },
    {
      label: "Final Disbursement",
      value: { ...a11yProps(2) },
      count: 0,
      active: false,
      visible: context?.CurrentRoleId === RoleEnum.LoanCommittee,
      id: "final-disbursement",
      target: LoanDashboardEventTarget.TabFinalDisbursementClick,
      module: LoanDashboardModules.FinalDisbursement,
    },
    {
      label: "Repayment Request",
      value: { ...a11yProps(2) },
      count: 0,
      active: false,
      visible:
        context?.CurrentRoleId === RoleEnum.Member ||
        context?.CurrentRoleId === RoleEnum.InternalTeam,
      id: "all-repayment",
      target: LoanDashboardEventTarget.TabAllRepaymentClick,
      module: LoanDashboardModules.AllRepayment,
    },
    // {
    //   label: "Pending Repayment",
    //   value: { ...a11yProps(2) },
    //   count: 0,
    //   active: false,
    //   visible: context?.CurrentRoleId === RoleEnum.Member || context?.CurrentRoleId === RoleEnum.InternalTeam,
    //   id: "pending-repayment",
    //   target: LoanDashboardEventTarget.TabPendingRepaymentClick,
    //   module: LoanDashboardModules.PendingRepayment,
    // }
    // add new tab here...s
  ]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  // return (
  //   <Box sx={{ width: "100%" }}>
  //     <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />
  //     <CustomTabPanel value={value} index={0}>
  //       <AllRequests />
  //     </CustomTabPanel>
  //     <CustomTabPanel value={value} index={1}>
  //       <PendingRequests />
  //     </CustomTabPanel>
  //     <CustomTabPanel value={value} index={2}>
  //       <AgreementRequests />
  //     </CustomTabPanel>
  //   </Box>
  // );

  const changeTab = (tabNum) => {
    const newTabs = [...tabs];
    newTabs.forEach((nt) => (nt.active = false));
    newTabs[tabNum].active = true;
    setTabs(newTabs);
  };

  const handleEvents = (
    target: LoanDashboardEventTarget,
    event: any = null
  ) => {
    let activeTabs = tabs.find((t) => t.active);

    switch (target) {
      case LoanDashboardEventTarget.TabAllRequestsClick:
        changeTab(0);
        break;
      case LoanDashboardEventTarget.TabApprovalPendingClick:
        changeTab(1);
        break;
      case LoanDashboardEventTarget.TabAgreementRequestClick:
        changeTab(2);
        break;
      case LoanDashboardEventTarget.TabFinalDisbursementClick:
        changeTab(3);
        break;
      case LoanDashboardEventTarget.FilterClick:
        setDashboardFilterOn(!dashboardFilterOn);
        break;
      case LoanDashboardEventTarget.SearchClick:
        setSearchText(event?.target?.value);
        break;
      case LoanDashboardEventTarget.ExportToExcelClick:
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          //exportToExcelFunction();
          ExportToExcel(
            dataCount,
            currentDataReqObj.searchText,
            currentDataReqObj.sortColumn,
            currentDataReqObj.sortDirection,
            currentDataReqObj.MemberId,
            currentDataReqObj.UnitCodeId,
            currentDataReqObj.TypeofApplicantId,
            currentDataReqObj.FromDate,
            currentDataReqObj.ToDate,
            currentDataReqObj.Status,
            currentDataReqObj.IsApproval,
            currentDataReqObj.IsAgreement,
            currentDataReqObj.IsFinalDisbursement,
            context?.CurrentRoleId,
            context?.Id,
            activeTabs
          );
        }
        break;
      case LoanDashboardEventTarget.TabAllRepaymentClick:
        changeTab(4);
        break;
      case LoanDashboardEventTarget.TabPendingRepaymentClick:
        changeTab(5);
        break;
    }
  };

  const exportToCSV = async (
    UnitCodeId,
    TypeofApplicantId,
    FromDate,
    ToDate,
    Status
  ) => {
    
    const params = {
      MemberNo: null,
      UnitCodeId: UnitCodeId,
      TypeofApplicantId: TypeofApplicantId,
      FromDate: FromDate,
      ToDate: ToDate,
      Status: Status,
    };

    let token = await fetchAuthToken();

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: LoanExportToCSV,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
       
        fileDownload(
          response.data,
          `LoanExportCSV_${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.txt`
        );
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;

    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0 no-gutters p-0">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 p-0">
                {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
                <div className="col-lg-12 p-0">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 no-gutters">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul
                          className="nav nav-pills  float-left"
                          id="pills-tab"
                          role="tablist"
                        >
                          {tabs.map((tab) => {
                            if (!tab.visible) return null;
                            return <TabsComponent tab={tab} key={tab.id} />;
                          })}
                        </ul>
                      </nav>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end no-gutters resp_d">
                      <div className="ser_resp">
                        <div className="col-lg-8 col-md-8 col-sm-12 p-0">
                          <div className="input-group">
                            <input
                              className="form-control py-2 border-right-0 border"
                              type="Search"
                              value={searchText}
                              placeholder="Search"
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                            <span className="input-group-append">
                              <div className="input-group-text bg-transparent">
                                <i className="fa fa-search"></i>
                              </div>
                            </span>
                          </div>
                        </div>
                        <Tooltip
                          title="Filters"
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                        >
                          <ButtonComponent
                            onClick={() =>
                              handleEvents(LoanDashboardEventTarget.FilterClick)
                            }
                            className="btn btn-submit"
                            icon={"fa fa-filter"}
                            value=""
                          />
                        </Tooltip>

                        <Tooltip
                          title="export to excel"
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                        >
                          <button
                            className="btn btn-submit"
                            onClick={() =>
                              handleEvents(
                                LoanDashboardEventTarget.ExportToExcelClick
                              )
                            }
                          >
                            <i className="fa fa-download"></i>
                          </button>
                        </Tooltip>
                        {context?.CurrentRoleId === RoleEnum.LoanCommittee && (
                          <Tooltip
                            title="export to CSV"
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                          >
                            <button
                              className="btn btn-submit"
                              onClick={() =>
                                exportToCSV(
                                  currentDataReqObj.UnitCodeId,
                                  currentDataReqObj.TypeofApplicantId,
                                  currentDataReqObj.FromDate,
                                  currentDataReqObj.ToDate,
                                  currentDataReqObj.Status
                                )
                              }
                            >
                              <i className="fas fa-file-csv"></i>
                            </button>
                          </Tooltip>
                        )}
                      </div>

                      <div>
                        {context?.CurrentRoleId === RoleEnum.Member && (
                          <ButtonComponent
                            className="btn btn-submit appl"
                            style={{
                              marginLeft: 5,
                              cursor: "pointer",
                            }}
                            icon={"fas fa-search-dollar"}
                            value={"Apply For Loan"}
                            onClick={() => {
                              navigate("/LoanModule", {
                                state: {
                                  Id: 0,
                                },
                              });
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          <AllRequestsFilters
            activeTab={tabs.find((t) => t.active)}
            dashboardFilterOn={dashboardFilterOn}
            setCurrentFilters={setCurrentFilters}
          />

          <LoanApprovalGrid
            searchText={searchText}
            setSearchText={setSearchText}
            activeTab={tabs.find((t) => t.active)}
            currentFilters={currentFilters}
            dataCount={dataCount}
            setDataCount={setDataCount}
            setCurrentDataReqObj={setCurrentDataReqObj}
          />
        </div>
      </div>
    </>
  );
};

export default LoanApprovalDashboard;
